import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {isBrowser, isMobile} from 'react-device-detect';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {getRecaptchaToken} from './../../../utilities/recaptcha/recaptcha';
import {callOpenWorkOrderForSaleJet} from '../../../utilities/openWorkOrder';

export const getCustomerCoreProducts = createAsyncThunk('coreProductsOfCostumer/getCustomerCoreProducts', async (result) => {
  try {
    return result;
  } catch (error) {
    return ['Cellular', 'Internet', 'Mapa', 'TV', 'Bundle', 'Error'];
  }
});

export const openWorkOrder = createAsyncThunk('serviceBoxWorkOrder/createWorkOrder', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    thunkAPI.dispatch(showAppLoader());
    const request = buildWorkOrderRequest(data, state);
    console.info('openWorkOrder - request', request);
    const result = await ProviderManager.getProviderData('createWorkOrder', request);
    const isSuccess = result.Body.isSuccess;

    const res = {
      isSuccess: isSuccess,
      data: data,
    };
    return res;
  } catch (error) {
    console.error('openWorkOrder - error : ', error);
    thunkAPI.dispatch(hideAppLoader());
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

function limitVisibleActions(scActions, maxCount) {
  let displayedActionsCount = 0;
  return [...scActions]
    .sort((a, b) => a.index - b.index)
    .map((scAction) => {
      if (!scAction.isAvailableToUser) {
        return {...scAction, mode: 'unavailable'};
      } else if (displayedActionsCount < maxCount) {
        ++displayedActionsCount;
        return {...scAction, mode: 'displayed'};
      } else {
        return {...scAction, mode: 'hidden'};
      }
    });
}

let ITEMS_COUNT = 0;

if (isMobile) {
  ITEMS_COUNT = Infinity;
}

if (isBrowser) {
  ITEMS_COUNT = 6;
}

const coreProductsOfCostumerSlice = createSlice({
  name: 'coreProductsOfCostumer',
  initialState: {
    userServices: [], //["TV", "Internet", "Cellphone", "Mapa"],
    scActions: [],
    maxActions: ITEMS_COUNT,
    showAll: false,
    selectedTab: 'SELF_CARE',
    isLoading: true,
    isOrganizationId: false,
    isWorkOrderSucceeded: '',
  },
  reducers: {
    selectTab: (state, action) => {
      return {
        ...state,
        selectedTab: action.payload,
        // showAll: false // If you want the "+" to not reset when switching tabs, remove this line
      };
    },
    setMobileMode: (state) => {
      return {
        ...state,
        maxActions: ITEMS_COUNT,
      };
    },
    setDesktopMode: (state) => {
      return {
        ...state,
        maxActions: ITEMS_COUNT,
      };
    },
    registerSCAction: (state, action) => {
      const actionToRegister = action.payload;
      const isAvailableToUser = (actionToRegister.actionServices || []).some((service) => (state.userServices || []).includes(service));

      const scActions = [
        ...state.scActions,
        {
          index: actionToRegister.actionIndex,
          isAvailableToUser,
          name: actionToRegister.actionName,
        },
      ];
      return {
        ...state,
        scActions: limitVisibleActions(scActions, state.showAll ? Infinity : state.maxActions),
      };
    },
    unregisterSCAction: (state, action) => {
      const actionToUnRegister = action.payload;

      const scActions = state.scActions.filter((scAction) => scAction.name !== actionToUnRegister.actionName);
      return {
        ...state,
        scActions: limitVisibleActions(scActions, state.showAll ? Infinity : state.maxActions),
      };
    },
    showAllActions: (state) => ({
      ...state,
      showAll: true,
      scActions: limitVisibleActions(state.scActions, Infinity),
    }),
    isOrganizationId: (state, action) => {
      if (action.payload == '623456') {
        state.isOrganizationId = true;
      }
    },
    resetIsWorkOrderSucceeded: (state, action) => {
      state.isWorkOrderSucceeded = '';
    },
  },
  extraReducers: {
    [getCustomerCoreProducts.fulfilled]: (state, action) => {
      if ((Array.isArray(action.payload) && action.payload.length === 0) || action.payload === null || !Array.isArray(action.payload)) {
        return {...state, userServices: ['Cellular', 'Internet', 'Mapa', 'TV', 'Bundle', 'Error'], isLoading: false};
      }
      return {...state, userServices: action.payload, isLoading: false};
    },
    [openWorkOrder.fulfilled]: (state, action) => {
      return {...state, isWorkOrderSucceeded: action.payload.isSuccess};
    },
  },
});

export const {
  selectTab,
  setMobileMode,
  setDesktopMode,
  registerSCAction,
  unregisterSCAction,
  showAllActions,
  isOrganizationId,
  resetIsWorkOrderSucceeded,
} = coreProductsOfCostumerSlice.actions;

export default coreProductsOfCostumerSlice.reducer;

function buildWorkOrderRequest(data, state) {
  let request = {};
  try {
    request = {
      banList: [],
      errorCode: 0,
      errorDescription: '',
      externalIdNum: '',
      firstName: state.authentication.loginData.userDetails.firstName,
      lastName: state.authentication.loginData.userDetails.lastName,
      identityNumber: state.authentication.loginData.userDetails.IDNumber,
      subscriber: state.authentication.loginData.userDetails.contactNumber,
      orderType: 'SELL_PRODUCTS_WORK_ORDER',
      psidList: [],
      movingApartment: null,
      saleJet: null,
      selfCareBusiness: {
        productType: data.productName,
        orgId: state.welcomeBlock.organizationId,
      },
      workOrderInfo: {
        workOrderCode: data.productWorkOrderCode,
        workOrderTeam: data.productWorkOrderTeam,
        productInfo: data.productName,

      },
    };
  } catch (error) {}

  return request;
}
